import React from 'react';
import { withSnackbar } from 'notistack';

import { getContactCentersList } from 'services/contact-center.service';

// components
import SnackMessage from 'components/Snackbar/SnackMessage';
import CustomSelect from 'components/CustomSelect/CustomSelect';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

const selectAllLabel = 'Select All';

class ReportController extends React.Component {
	state = {
		granularityList: [
			{
				label: 'Hourly',
				value: 'hour',
			},
			{
				label: 'Daily',
				value: 'day',
			},
		],
		isSavingPdf: false,
		contactCenterList: [{ value: 'all', label: selectAllLabel }],
	};

	handleGranularity = async (value) => {
		await this.props.setGranularity(value);
		this.props.getReports();
	}

	handleContactCenter = async (value, label) => {
		const callCenterName = label === selectAllLabel ? 'All' : label;
		await this.props.setContactCenter(value, callCenterName);
		this.props.getReports();
	}

	async getCallCenters() {
		try {
			const data = await getContactCentersList();
			const formattedCallCenters = data.map(({ name, _id }) => ({
				value: _id,
				label: name,
			}));
			formattedCallCenters.unshift({
				value: 'all',
				label: 'Select All',
			});
			await this.props.setContactCenter('all', 'All');
			this.setState({ contactCenterList: formattedCallCenters });
		} catch (error) {
			this.props.enqueueSnackbar(error.resolvedErrorMessage, {
				content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
			})
		}
	}

	downloadAll = () => {
		this.setState({ isSavingPdf: true });
		this.props.downloadAll()
		setTimeout(() => {
			this.setState({ isSavingPdf: false });
		}, 1000);
	}

	componentDidMount() {
		this.getCallCenters();
	}

	render() {
		return (
			<GridContainer
				justify="space-between"
				alignItems="center"
				direction="row"
				style={{ marginBottom: '20px' }}
			>
				<GridItem xs={12} sm={8} md={9} lg={9}>
					<GridContainer>
						<GridItem xs={12} sm={6} md={6} lg={6}>
							<CustomSelect
								label="Granularity"
								items={this.state.granularityList}
								onChange={this.handleGranularity}
								value={this.props.granularity}
							/>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} lg={6}>
							<CustomSelect
								label="Contact Center"
								items={this.state.contactCenterList.filter((option) => option && option.label)}
								onChange={this.handleContactCenter}
								value={this.props.contactCenter}
							/>
						</GridItem>
					</GridContainer>
				</GridItem>
				<GridItem xs={12} sm={3} md={3} lg={3}>
					<GridContainer
						justify="flex-end"
						alignItems="center"
						direction="row"
					>
						<GridItem>
							<Button
								color="danger"
								fullWidth
								round
								style={{
									maxWidth: '150px',
									marginBottom: '-12px',
								}}
								disabled={this.state.isSavingPdf}
								onClick={this.downloadAll}
							>
								Download all
							</Button>
						</GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		)
	}
}

export default withSnackbar(ReportController);
